import { lazy } from 'react';

export const TrackUploadPage = lazy(() => import('./controller.js'));
